import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { pickerOptions, typeList } from "./js/config";
export default {
  name: "user-city-master-settlement",
  data: function data() {
    return {
      searchForm: {
        page: 1,
        count: 20
      },
      // 搜索表单
      dateTime: [],
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      typeList: typeList,
      pickerOptions: pickerOptions
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    resetTable: function resetTable() {
      this.searchForm = {
        page: 1,
        count: 20
      };
      this.dateTime = [];
      this.getData("search");
    },
    pageChange: function pageChange(pn) {
      this.searchForm.page = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _res$data, _res$data2;
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (type === "search") {
                _this2.searchForm.page = 1;
              }
              _this2.tableLoading = true;
              _context2.n = 1;
              return _this2.$api.getCityMasterSettlementList(_objectSpread(_objectSpread({}, _this2.searchForm), {}, {
                start: _this2.dateTime[0] || "",
                end: _this2.dateTime[1] || ""
              }));
            case 1:
              res = _context2.v;
              _this2.tableData = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.list) || [];
              _this2.total = (res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.page) === null || _res$data2 === void 0 ? void 0 : _res$data2.total) || 0;
              _this2.tableLoading = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  }
};